import { useQuery } from '@tanstack/react-query';

import { fetchVenues } from 'apis/restaurant-api/merchant-admin/venue/api';

export const useVenues = ({ enabled }: { enabled: boolean }) => {
  const {
    data: venues,
    isLoading: isLoadingVenues,
    error: venuesError,
  } = useQuery(['/v1/merchant-admin/venues'], () => fetchVenues(), {
    enabled,
    initialData: [],
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return { venues, isLoadingVenues, venuesError };
};
